import { Grid, makeStyles, Typography } from 'beam'
import { FC } from 'react'

const useStyles = makeStyles(theme => ({
  description: {
    padding: theme.spacing(1, 2, 3, 0),
  },
}))

export interface DescriptionProps {
  description: string,
}

const Description: FC<DescriptionProps> = ({ description }) => {
  const classes = useStyles()
  return (
    <Grid item xs={12} className={classes.description}>
      <Typography variant="body1">{description}</Typography>
    </Grid>
  )
}

export default Description
